import React from 'react';
import MarkAsUrgentCheckbox from 'common/components/MarkAsUrgentCheckbox';
import PropTypes from 'prop-types';
import { useUpdateEnrollmentRequest } from '../hooks/useUpdateEnrollmentRequest';

const MarkEnrollmentAsUrgentCheckbox = ({ enrollmentId, isUrgent }) => {
  const updateEnrollmentRequest = useUpdateEnrollmentRequest(() => {});

  return (
    <MarkAsUrgentCheckbox
      id={enrollmentId}
      checked={isUrgent}
      onUpdate={updateEnrollmentRequest}
    />
  );
};

MarkEnrollmentAsUrgentCheckbox.propTypes = {
  enrollmentId: PropTypes.string.isRequired,
  isUrgent: PropTypes.bool,
};

MarkEnrollmentAsUrgentCheckbox.defaultProps = {
  isUrgent: undefined,
};

export default MarkEnrollmentAsUrgentCheckbox;
